const SRC = {
  hello: "/mascots/rabbit-wave.png",
  thumbsup: "/mascots/rabbit-thumbsup.png",
  sleep: "/mascots/rabbit-sleep.png",
  trophy: "/mascots/rabbit-trophy.png",
  camera: "/mascots/rabbit-camera.png",
  heart: "/mascots/rabbit-heart.png",
  idea: "/mascots/rabbit-idea.png",
  face: "/mascots/rabbit-face.png",
};

const ANIM = {
  float: "mascot-float",
  bounce: "mascot-bounce",
  wiggle: "mascot-wiggle",
  sway: "mascot-sway",
  none: "",
};

// Kyno, le lapin mascotte de Kynoria. Décoratif : plusieurs poses selon le contexte.
export const Mascot = ({ pose = "hello", size = 96, anim = "float", delay = 0, className = "" }) => (
  <span
    className={`inline-block pointer-events-auto mascot-hover ${ANIM[anim] ?? ANIM.float} ${className}`}
    style={{ animationDelay: `${delay}ms` }}
  >
    <img
      src={SRC[pose] || SRC.hello}
      alt=""
      aria-hidden="true"
      data-testid={`mascot-${pose}`}
      style={{ width: size }}
      className="select-none drop-shadow-[0_10px_24px_rgba(22,35,61,0.14)]"
      draggable="false"
    />
  </span>
);

export default Mascot;
